var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_vm._t("navigation"),_vm._t("header"),_vm._t("default"),_vm._t("dialogs")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }